import React, { useState, useContext } from 'react';
import { QrReader } from 'react-qr-reader';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

import { LocalizationContext } from '../App';


const LoupeQrScannerComponent = (props) => {
    
    const localizer = useContext(LocalizationContext);

    const navigate = useNavigate();

    const [ scanResult, setScanResult ] = React.useState('');
    const [ hasError, setHasError ] = React.useState(false);
    const [ errorMsg, setErrorMsg ] = React.useState(''); 

    const resetData = () => {
        setScanResult('');
    }
    
    const openActivity = () => {

        if( scanResult.includes(process.env.REACT_APP_BASE_URI + "/start/") == true ) {

            var tmp = scanResult.split("/");
            // tmp is an array of x length; we want the last piece
            var code = tmp.pop();
            navigate('/start/' + code, { replace : true });

        } else {
            resetData();
            setHasError(true);
            setErrorMsg(localizer.strings.getString("errors.camera.qr.invalid"));
        }
    }

    const scanAgain = () => {
        setScanResult('');
    }

    return (

        <LocalizationContext.Consumer>
        { ({strings, setLanguage}) => 
      <>

        { hasError == false &&
            <p>{errorMsg}</p>
        }


        { scanResult == '' ? (

            <QrReader
                style={{ width: '100%' }}
                constraints={ {facingMode : { exact : "environment" } } }
                onResult={(result, error) => {
                    if (!!result) {
                        setScanResult(result?.text);
                    }

                    if (!!error) {
                        setHasError(true);
                    }
                }} />

        ) : (

            <>
                <p>{scanResult}</p>
                <Button onClick={openActivity}>{strings.getString("controls.buttons.camera.qr.open")}</Button>
                <Button onClick={scanAgain}>{strings.getString("controls.buttons.camera.qr.retry")}</Button>
            </>

        )}


        
        
      </>
    }
    </LocalizationContext.Consumer>
    );
}
export default LoupeQrScannerComponent;